import { render, staticRenderFns } from "./unicomDeal9.vue?vue&type=template&id=82ae5dd4&scoped=true"
import script from "./unicomDeal9.vue?vue&type=script&lang=js"
export * from "./unicomDeal9.vue?vue&type=script&lang=js"
import style0 from "./unicomDeal9.vue?vue&type=style&index=0&id=82ae5dd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82ae5dd4",
  null
  
)

export default component.exports